module.exports = __webpack_public_path__ + "static/lby-877b70321578197eafb297d7e83c62bd.png";